(function() {

	var State = include("springroll.State"),
		Texture = include("PIXI.Texture"),
		Sprite = include("PIXI.Sprite"),
		Point = include("PIXI.Point"),
		GeomUtils = include("heist.GeomUtils"),
		Tween = include("createjs.Tween"),
		Joke = include("heist.Joke"),
		SearchClue = include("heist.SearchClue"),
		Sound = include("springroll.Sound"),
		TweenHelper = include("springroll.TweenHelper");

	var ClueState = function(options)
	{
		State.call(this, new heist.CluePanel(), options);

		this.voPlayer = this.app.voPlayer;

		this.levelConfig = null;
		this.clues = null;
		this.jokes = null;
		var clueConfig = this.clueConfig = this.app.config.game.clues;
		this.cluesFound = 0;
		this.tweeningClues = false;

		this.prevPosition = new Point();
		this.inactiveTimer = 0;
		this.inactiveTimeouts = 0;
		this.inactiveTimeoutTime = clueConfig.inactiveTimer;
		this.failureTimer = 0;
		this.failureTimeouts = 0;
		this.failureTimeoutTime = clueConfig.failureTimer;
		this.uiClicks = 0;
		this.totalTime = 0;
		this.timeSinceTimeout = -1;
		
		this.appIsPlaying = false;

		this.glassCursor = null;

		this.update = this.update.bind(this);
		this.resize = this.resize.bind(this);
		
		this.on("loading", this.onLoading);
		this.on("loaded", this.onLoaded);
	};

	// Extend State
	var s = State.prototype;
	var p = ClueState.prototype = Object.create(s);

	var helperPoint = new Point();

	p.enter = function()
	{
		//for debugging, make sure that a letter is selected
		if(DEBUG && !this.app.currentCrimeConfig)
			this.app.selectLetter();
		
		this.levelConfig = this.app.currentCrimeConfig;
		
		s.enter.call(this);
	};
	
	p.onLoading = function(assets)
	{
		var background = this.levelConfig.background;
		assets.append(this.app.config.assets.clue_bgs[background]);
	};

	p.onLoaded = function()
	{
		this.panel.setup();

		var config = this.app.config;
		
		//build the level
		this.buildLevel();
		
		//set up the clue finder, according to the platform
		var clueConfig = this.clueConfig;
		var glassCursor = this.glassCursor = new Sprite(Texture.fromFrame("MagnifyingGlass"));
		var scale = glassCursor.scale.x = glassCursor.scale.y = this.scaling.scale;
		if(this.app.hasTouch)
		{
			glassCursor.pivot.x = clueConfig.glassHandle.x;
			glassCursor.pivot.y = clueConfig.glassHandle.y;
			this.app._sparkles.updateSpawnPos(
				scale * (clueConfig.glassOrigin.x - clueConfig.glassHandle.x),
				scale * (clueConfig.glassOrigin.y - clueConfig.glassHandle.y));
		}
		else
		{
			glassCursor.pivot.x = clueConfig.glassOrigin.x;
			glassCursor.pivot.y = clueConfig.glassOrigin.y;
		}

		this.inactiveTimer = clueConfig.inactiveTimer;
		this.failureTimer = clueConfig.failureTimer;
		this.failureTimeouts = this.inactiveTimeouts = 0;

		this.cluesFound = 0;
		this.tweeningClues = false;
		this.totalTime = 0;
		this.uiClicks = 0;
		this.timeSinceTimeout = -1;

		this.app.music = "GameLoop";
	};

	p.buildLevel = function()
	{
		this.panel.addBackground(this.levelConfig.background);
		var clues = this.levelConfig.clues, i;
		this.clues = [];
		for(i = 0; i < clues.length; ++i)
		{
			var clueData = clues[i];
			var clue = new SearchClue(this, clueData.id);
			clue.position.x = clueData.x;
			clue.position.y = clueData.y;
			if(clueData.above)
				this.panel.levelContainer.addChild(clue);
			else
				this.panel.hiddenClueContainer.addChild(clue);
			this.clues.push(clue);
		}
		this.jokes = [];
		var jokes = this.levelConfig.jokes;
		if(jokes)
		{
			for(i = 0; i < jokes.length; ++i)
			{
				var joke = new Joke(this, jokes[i]);
				this.panel.levelContainer.addChild(joke);
				this.jokes.push(joke);
			}
		}
		//add hint sparkle to top
		this.panel.levelContainer.addChild(this.panel.hintSparkle);
	};

	p.enterDone = function()
	{
		this.appIsPlaying = true;
		//tracking
		this.app.trackEvent(["GameBEGIN",
			"cluefinder_begin_letter_tested_" + this.levelConfig.letter]);
		//instructions
		var voList, callback;
		if(this.app.totalPlays > 1)
		{
			this.enableJokes();
			this.enableCursor();
			voList = ["Elmo_TheLetter", "Elmo_" + this.levelConfig.letter];
			if(this.app.cutsceneSkipped)
				voList.push("Elmo_ItsClue");
		}
		else
		{
			callback = this.enableJokes.bind(this);
			if(this.app.cutsceneSkipped)
			{
				voList = ["Elmo_TheLetter", "Elmo_" + this.levelConfig.letter, "Elmo_ItsClue",
					"Elmo_MaybeMoreClues", this.enableCursor.bind(this), "Elmo_MoveClueFinder"];
			}
			else
			{
				voList = ["Elmo_TheLetter", "Elmo_" + this.levelConfig.letter,
					"Elmo_MaybeMoreClues", this.enableCursor.bind(this), "Elmo_MoveClueFinder"];
			}
		}
		this.voPlayer.play(voList, callback, callback);
	};
	
	p.enableCursor = function()
	{
		this.app.setCursor(this.glassCursor);
		//center the cursor
		this.app.cursor.x = this.app.display.width * 0.5 + 40;
		this.app.cursor.y = this.glassCursor.pivot.y * this.glassCursor.scale.y;
		this.app.on("update", this.update);
		this.app.on("resize", this.resize, -2);
		
		this.panel.targetUI.enable();
	};

	p.enableJokes = function()
	{
		for(var i = 0; i < this.jokes.length; ++i)
			this.jokes[i].enable();
	};

	p.update = function(elapsed)
	{
		//update the particle emitters
		this.panel.hintEmitter.update(elapsed * 0.001);
		this.panel.clueEmitter.update(elapsed * 0.001);
		
		//if a clue is tweening, then don't allow a new clue to be found or timeouts to happen
		if(this.tweeningClues) return;
		
		var voPlayer = this.voPlayer;
		
		//determine if the cursor moved - if so, reset timeouts
		var cursorPosition = this.app.cursor.position;
		if(cursorPosition.x != this.prevPosition.x || cursorPosition.y != this.prevPosition.y)
		{
			this.inactiveTimer = this.inactiveTimeoutTime;
			this.prevPosition.x = cursorPosition.x;
			this.prevPosition.y = cursorPosition.y;
			
			this.resetTimeouts();
		}
		//see what clues we might be looking at based on the cursor location
		var spawnPos = this.app._sparkles.spawnPos;
		Point.localToLocal(this.app.cursor, this.panel.hiddenClueContainer, spawnPos.x, spawnPos.y,
			helperPoint);
		var i, clues = this.clues, clue, clueSparkling = false;
		for(i = 0; i < clues.length; ++i)
		{
			clue = clues[i];
			if(!clue.visible)
				continue;
			var targX = helperPoint.x - clue.position.x,
				targY = helperPoint.y - clue.position.y;
			if(clue.hitArea.contains(targX, targY))
			{
				Sound.instance.play("SFX_FoundClue");
				this.panel.levelContainer.addChild(clue);
				//reset the timeout for finding stuff
				this.failureTimer = this.failureTimeoutTime;
				this.failureTimeouts = 0;
				//also cancel any hint sparkles
				this.panel.hintEmitter.emit = false;
				this.tweeningClues = true;
				var tweenList = this.app.config.game.clues.clueCenterTweenIn;
				var tween = TweenHelper.build(clue, tweenList);
				tween.call(this.onClueIn.bind(this, clue));
				
				//see if the instructions were playing.
				if(voPlayer.playing && voPlayer.voList.indexOf("Elmo_PaperWithLetter") > -1)
				{
					this.app.trackEvent(["Skipped",
						"InstructionsCluefinder_" + this.app.totalPlays,
						Math.round(voPlayer.getElapsed())]);
				}
				voPlayer.stop();
				
				//preload VO
				Sound.instance.preload("Elmo_" + clue.id + "End");
				break;
			}
			else if(clue.sparkleArea.contains(targX, targY))
			{
				clueSparkling = true;
				var emitter = this.panel.clueEmitter;
				emitter.updateSpawnPos(clue.position.x, clue.position.y);
				emitter.resetPositionTracking();
				emitter.emit = true;
			}
		}
		if(!clueSparkling && this.panel.clueEmitter.emit)
			this.panel.clueEmitter.emit = false;

		//if VO is not playing
		if(this.inactiveTimer > 0 && !voPlayer.playing)
		{
			this.inactiveTimer -= elapsed;
			if(this.inactiveTimer <= 0)
			{
				if(this.timeSinceTimeout < 0)
				{
					this.timeSinceTimeout = 0;
					this.app.trackEvent(["TimeoutPlay", "cluefinder"]);
				}
				++this.inactiveTimeouts;
				this.inactiveTimer = this.inactiveTimeoutTime;
				if(this.inactiveTimeouts == 1)
				{
					voPlayer.play("Elmo_TO1_MoveFinder");
				}
				else if(this.inactiveTimeouts == 2)
				{
					voPlayer.play(["Elmo_TO2_ToMoveFinder",
						this.app.hasTouch ? "Elmo_TO2_DragFinger" : "Elmo_TO2_MoveMouse"]);
				}
				else//3+
				{
					voPlayer.play(["Elmo_TO5_KeepLookingWithLetter",
						"Elmo_" + this.levelConfig.letter]);
					this.inactiveTimeouts = 0;
				}
			}
		}
		//if VO is also not playing
		if(this.failureTimer > 0 && !voPlayer.playing)
		{
			this.failureTimer -= elapsed;
			if(this.failureTimer <= 0)
			{
				if(this.timeSinceTimeout < 0)
				{
					this.timeSinceTimeout = 0;
					this.app.trackEvent(["TimeoutPlay", "cluefinder"]);
				}
				++this.failureTimeouts;
				this.failureTimer = this.failureTimeoutTime;
				if(this.failureTimeouts == 1)
				{
					voPlayer.play("Elmo_TO3_NothingThere");
				}
				else//2+
				{
					voPlayer.play("Elmo_TO4_TryHere");
					var hiddenClues = [];
					for(i = 0; i < clues.length; ++i)
					{
						if(clues[i].visible)
							hiddenClues.push(clues[i]);
					}
					Sound.instance.play("SFX_HintSparkle");
					this.panel.showHint(hiddenClues.random());
					this.failureTimeouts = 0;
				}
			}
		}
		
		this.totalTime += elapsed;
		
		if(this.timeSinceTimeout >= 0)
		{
			this.timeSinceTimeout += elapsed;
		}
	};
	
	p.resetTimeouts = function()
	{
		if(this.timeSinceTimeout > 0)
		{
			this.app.trackEvent(["TOReEnage", "cluefinder", Math.round(this.timeSinceTimeout)]);
		}
		this.timeSinceTimeout = -1;
	};

	p.playVO = function(vo)
	{
		if(this.voPlayer.playing || this.tweeningClues) return false;

		this.voPlayer.play(vo);
		this.inactiveTimer = this.inactiveTimeoutTime;
		this.resetTimeouts();
		return true;
	};
	
	//when clue is big at the middle of the screen
	p.onClueIn = function(clue)
	{
		this.voPlayer.play("Elmo_" + clue.id + "End", this.tweenClueOut.bind(this, clue));
	};
	
	//when big clue should shrink down to disappear from the level
	p.tweenClueOut = function(clue)
	{
		var tweenList = this.app.config.game.clues.clueCenterTweenOut;
		var tween = TweenHelper.build(clue, tweenList);
		tween.call(this.onMidTween.bind(this, clue));
	};
	
	//when big clue has disappeared and should appear in the UI instead
	p.onMidTween = function(clue)
	{
		clue.visible = false;
		var clueName = clue.id;
		//tween in the UI clue
		clue = this.panel.targetUI.setClueFound(this, clueName);
		var tweenList = this.app.config.game.clues.clueUITween;
		var tween = TweenHelper.build(clue, tweenList);
		tween.call(this.onTweenIn.bind(this, clue));
	};
	
	//when clue has finished doing the multi-step 'discovered' animation
	p.onTweenIn = function(clue)
	{
		this.tweeningClues = false;
		var clueName = clue.id;
		++this.cluesFound;
		Sound.instance.play("SFX_NewClue" + this.cluesFound);
		if(this.cluesFound >= this.clues.length)
		{
			var i;
			var clues = this.panel.targetUI.clues;
			for(i = 0; i < clues.length; ++i)
				clues[i].disable();
			for(i = 0; i < this.jokes.length; ++i)
				this.jokes[i].disable();
			
			this.voPlayer.play(["Elmo_CA3_AllCluesWithLetter", "Elmo_" + this.levelConfig.letter],
								this.endState.bind(this));
		}
		else if(this.cluesFound == 2)
		{
			this.voPlayer.play(["Elmo_CA2_AnotherClueFindLetter",
								"Elmo_" + this.levelConfig.letter]);
		}
		else if(this.cluesFound == 1)
		{
			this.voPlayer.play(["Elmo_CA1_AClueKeepLookingForLetter",
								"Elmo_" + this.levelConfig.letter]);
		}
	};

	p.endState = function()
	{
		//do tracking
		var itemNames = this.clues[0].id + "," + this.clues[1].id + "," + this.clues[2].id;
		this.app.trackEvent(["GameSUCCESS",
			"cluefinder_complete_letter_tested_" + this.levelConfig.letter + "_itemsfound_" +
				itemNames,
			Math.round(this.totalTime)]);
		this.app.trackEvent(["GameSUCCESSInfo",
			"cluefinder_complete_letter_tested_" + this.levelConfig.letter + "_letterclicks_" +
				this.uiClicks]);
		
		this.appIsPlaying = false;
		
		//go to the next stage
		this.app.cutsceneData =
		{
			nextState: "suspect",
			cutscene: "scene2",
			skipLabel: "CutScreen2"
		};
		this.manager.state = "cutscene";
	};

	p.resize = function(w, h)
	{
		this.glassCursor.scale.x = this.glassCursor.scale.y = this.scaling.scale;
		var clueConfig = this.clueConfig;
		var scale = this.scaling.scale;
		if(this.app.hasTouch)
		{
			this.app._sparkles.updateSpawnPos(
				scale * (clueConfig.glassOrigin.x - clueConfig.glassHandle.x),
				scale * (clueConfig.glassOrigin.y - clueConfig.glassHandle.y));
		}
	};

	p.exitStart = function()
	{
		this.app.setCursor(null);
		this.app.off("update", this.update);
		this.app.off("resize", this.resize);
		this.voPlayer.stop();
	};

	p.exit = function()
	{
		if(this.appIsPlaying)
		{
			this.app.trackEvent(["GameINCOMPLETE",
				"cluefinder_incomplete_number_of_items_found_0" + this.cluesFound,
				this.cluesFound]);
			this.app.trackEvent(["Quit", "cluefinder"]);
		}
		
		var background = this.levelConfig.background;
		this.app.unload(this.app.config.assets.clue_bgs[background]);
		
		if(!this.clues) return;
		
		this.panel.teardown();
		var i;
		for(i = 0; i < this.clues.length; ++i)
			this.clues[i].destroy();
		for(i = 0; i < this.jokes.length; ++i)
			this.jokes[i].destroy();
		this.jokes = null;
		this.clues = this.glassCursor = null;
		this.tweeningClues = false;
	};

	p.destroy = function()
	{
		var p = this.panel;
		s.destroy.call(this);
		if(p.destroy)
			p.destroy();
		
		this.update = this.resize = null;
	};

	namespace('heist').ClueState = ClueState;
}());